export default __webpack_public_path__ + "static/phone_b.9db922063caf9c591ef89a9ce49f1c54.png";